import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FieldType, FormlyModule } from '@ngx-formly/core';
import { FormlyPrimeNGModule } from '@ngx-formly/primeng';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { Subscription } from 'rxjs';
import { ICategory } from 'src/app/EBMSuite/models/item.model';
import { ItemCategoryService } from 'src/app/EBMSuite/services/item-categories/item-category.service';

interface AutoCompleteCompleteEvent {
  originalEvent: Event;
  query: string;
}
@Component({
  standalone: true,
  selector: 'tags-formly-field',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormlyPrimeNGModule,
    FormlyModule,
    AutoCompleteModule
  ],
  template: `
    <p-autoComplete
      [suggestions]="categories"
      [dropdown]="true"
      (completeMethod)="filterCategories($event)"
      [formControl]="$any(formControl)"
      [formlyAttributes]="field"
      [forceSelection]="false"
      field="name"
    ></p-autoComplete>
    <!-- [readonly]="false" -->
  `
})
export class CategoryAutocompleteFormlyField extends FieldType implements OnInit {
  subscription = new Subscription();
  categories: ICategory[] = [];

  constructor(private itemCategoryService: ItemCategoryService) {
    super();
  }
  ngOnInit(): void {
    this.getAllCategories();
  }

  getAllCategories(): void {
    this.subscription.add(
      this.itemCategoryService.getCategories().subscribe({
        next: (res) => {
          this.categories = res.result;
        }
      })
    );
  }
  filterCategories(event: AutoCompleteCompleteEvent) {
    const filtered: any[] = [];
    const query = event.query;

    for (let i = 0; i < (this.categories as any[]).length; i++) {
      const category = (this.categories as any[])[i];
      if (category.name.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        filtered.push(category);
      }
    }
    this.categories = filtered;
  }
}
